import React from 'react';
import { titleMRClass, inputFormHeightOption } from "src/components/common/common";

interface KioskSwitchButtonFormProps {
  title?: string;
  titleWidth?: number;
  value: 'Y' | 'N';
  onChange: (name: string, newValue: 'Y' | 'N') => void;
  name: string;
  editable?: boolean;
  titleless?: boolean;
  wrapperOption?: {
    wrapperStyle?: string;
    titleStyle?: string;
    inputStyle?: string;
  };
}

export const KioskSwitchButtonForm: React.FC<KioskSwitchButtonFormProps> = ({
  title,
  titleWidth,
  value,
  onChange,
  name,
  editable = true,
  titleless = false,
  wrapperOption = {
    wrapperStyle: "w-[220px] min-w-[220px] mr-[10px] mb-[5px]",
    titleStyle: "w-[150px] min-w-[150px]",
    inputStyle: "w-[100px] min-w-[100px]"
  },
}) => {

  const handleToggle = () => {
    if (editable) {
      onChange(name, value === 'Y' ? 'N' : 'Y');
    }
  };

  return (
    <div className={`flex items-center ${inputFormHeightOption} ${wrapperOption.wrapperStyle}`} style={titleWidth ? { width: 'max-content' } : undefined}>
      <p
        className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${titleless ? 'hidden' : ''}`}
        style={titleWidth ? { width: titleWidth, minWidth: titleWidth, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } : undefined}
        title={title}
      >
        {title}
      </p>
      <div
        className={`flex items-center ${wrapperOption.inputStyle} h-full`}
        onClick={handleToggle}
      >
        <div
            className={`relative flex items-center w-[74px] rounded-[4px] h-full transition-colors duration-300
						border-[1px] border-gray-300
						${editable 
							? (value === 'Y' ? 'bg-blue-dark' : 'bg-gray-400') + ' cursor-pointer' 
							: 'bg-gray-100 cursor-not-allowed'
						}`
					}
        >
            <div
                className={`absolute w-[34px] h-[26px] bg-white shadow-md transform transition-transform duration-200 ease-in-out 
				${
					value === 'Y' ? 'translate-x-[2px]' : 'translate-x-[36px]'
				}`}
            />
            <span className={`absolute left-[12px] text-[16px] font-semibold ${value === 'Y' ? 'text-blue-dark' : 'text-gray-200'}`}>
                Y
            </span>
            <span className={`absolute right-[12px] text-[16px] font-semibold ${value === 'Y' ? 'text-gray-200' : 'text-gray-700'}`}>
                N
            </span>
        </div>
      </div>
    </div>
  );
};
